import { defineComponent, createElementBlock, openBlock, createVNode, withCtx, renderSlot } from 'vue';
import _sfc_main$1 from './basler-components.es224.js';
/* empty css                        */

const _hoisted_1 = { class: "text-media-block" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "TextMediaBlock",
  props: {
    media: {},
    textSide: { default: "left" },
    textLead: { type: Boolean, default: false },
    textCentered: { type: Boolean, default: true },
    offsetMediaLeft: { type: Boolean, default: false },
    offsetMediaRight: { type: Boolean, default: false },
    offsetTextLeft: { type: Boolean, default: false },
    offsetTextRight: { type: Boolean, default: false },
    slotContent: {}
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        createVNode(_sfc_main$1, {
          media: _ctx.media,
          "text-side": props.textSide,
          "text-lead": props.textLead,
          "text-centered": props.textCentered,
          "offset-media-left": props.offsetMediaLeft,
          "offset-media-right": props.offsetMediaRight,
          "offset-text-left": props.offsetTextLeft,
          "offset-text-right": props.offsetTextRight
        }, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 8, ["media", "text-side", "text-lead", "text-centered", "offset-media-left", "offset-media-right", "offset-text-left", "offset-text-right"])
      ]);
    };
  }
});

export { _sfc_main as default };
